const React = require('react');
const createReactClass = require('create-react-class');
const FuzzyReaction = require('../../../bootstrap').FuzzyReaction;
const assign = require('object-assign');
const Form = FuzzyReaction.Components.ResourceBinding.Form.Form;
const ResourceActions = FuzzyReaction.Actions.ResourceActions;
const Button = FuzzyReaction.Components.Global.Button;
const Column = Form.Column;
const Row = Form.Row;
const FormStore = FuzzyReaction.Stores.FormStore;
const CmsUserStore = FuzzyReaction.Stores.CmsUserStore;
const InstructorsStore = require('../../../stores/InstructorsStore');

const EditInstructor = createReactClass({
    displayName: 'EditInstructor',

    getInitialState: function () {
        return {
            workingResource: {},
            params: {},
            formIsValid: false
        }
    },

    resourceActions: new ResourceActions('instructors'),
    genreActions: new ResourceActions('genres'),

    /**
     * Edit user form key
     */
    formKey: 'editUser',

    /**
     * Resource action options
     */
    getOptions: {
        modifiers: {
            include: ['user', 'genres']
        },
        dataNode: 'data'
    },

    sendOptions: {
        modifiers: {},
        dataNode: 'data'
    },

    /**
     * Determine the page title based on present data
     *
     * @returns {string}
     * @private
     */
    _determinePageTitle: function () {
        if (this.state.params.id === 'me') {
            return 'My Profile';
        } else if (typeof this.state.workingResource.id !== 'undefined') {
            return this.state.workingResource.name;
        }

        return 'Manage Instructor';
    },

    /**
     * Request instructor data
     *
     * @param modifiers
     */
    requestInstructorData: function (modifiers) {
        this.getOptions.modifiers = assign(this.getOptions.modifiers, modifiers, {});

        // Determine whether we need to request my data
        const userId = this.state.params.id === 'me' ? this.state.workingResource.id : this.state.params.id;

        this.resourceActions.getResource(userId, this.getOptions);
    },

    /**
     * If I don't exist in the CmsUserStore, register a change listener to find out when I exist
     *
     * @return void
     */
    listenToCmsUserChanges: function () {
        CmsUserStore.addChangeListener(this.handleCmsUserChanges);
    },

    /**
     * Get my information from the CmsUserStore
     *
     * @return void
     */
    handleCmsUserChanges: function () {
        const me = CmsUserStore.me();

        this.setState({
            workingResource: me
        }, function () {
            // Request my data
            this.requestInstructorData();

            // No longer need to listen to changes, remove listener
            CmsUserStore.removeChangeListener(this.handleCmsUserChanges);
        });
    },

    /**
     * Register event listeners and fire request for data
     */
    componentDidMount: function () {
        const params = this.props.match.params || {};

        this.setState({
            params: params,
            resourceOperation: typeof params.id === 'undefined' ? 'create' : 'edit'
        }, function () {
            // An existing user
            if (this.state.resourceOperation === 'edit') {
                if (params.id === 'me') {
                    const me = CmsUserStore.me();

                    // I don't exist yet
                    if (typeof me.id === 'undefined') {
                        // Wait for /me request to complete
                        this.listenToCmsUserChanges();
                    } else {
                        // I already exist, request my instructor data
                        this.setState({
                            workingResource: me
                        }, function () {
                            this.requestInstructorData();
                        });
                    }
                } else {
                    // I am not the subject of attention :(
                    this.requestInstructorData();
                }
            }
        });

        this.changeListener = this._onChange;
        InstructorsStore.addChangeListener(this.changeListener);
        FormStore.addChangeListener(this.bindResource);
    },

    /**
     * Deregister an event listener
     */
    componentWillUnmount: function () {
        InstructorsStore.removeChangeListener(this.changeListener);
        FormStore.removeChangeListener(this.bindResource);
    },

    /**
     * Change handler for FormStore changes
     */
    bindResource: function () {
        this.setState({
            workingResource: FormStore.getResource(this.formKey),
            formIsValid: FormStore.isFormValid(this.formKey)
        });
    },

    /**
     * Action handlers
     *
     * @param action
     */
    handleAction: function (action) {
        switch (action) {
            case 'save':
                this.performOperation();
                break;
            case 'goBack':
                this.props.history.push('/instructors');
                break;
        }
    },

    /**
     * Handle change events
     *
     * @private
     */
    _onChange: function () {
        this.setState({
            workingResource: InstructorsStore.getResource()
        });
    },

    /**
     * Fire the activate user action
     */
    performOperation: function () {
        if (this.state.resourceOperation === 'edit') {
            this.resourceActions.updateResource(this.state.workingResource, this.sendOptions);
        } else if (this.state.resourceOperation === 'create') {
            this.resourceActions.createResource(this.state.workingResource, this.sendOptions);
        }
    },

    /**
     * Require some validations for the instructor
     *
     * @returns {boolean}
     * @private
     */
    _isInstructorValid: function () {
        const instructor = this.state.workingResource;

        if (typeof instructor.user === 'undefined') {
            return false;
        }

        if (typeof instructor.image === 'undefined' || instructor.image === null) {
            return false;
        }

        // Require a password for new instructors
        if (typeof instructor.id === 'undefined' &&
            (typeof instructor.user.password === 'undefined' || instructor.user.password.length < 6)) {
            return false;
        }

        return !(typeof instructor.user.username === 'undefined' || instructor.user.username.length < 4);
    },

    render: function () {
        const genderSelect = [
            {label: 'Male', value: 0},
            {label: 'Female', value: 1},
            {label: 'Other', value: 2}
        ];

        console.log('instructor is', this._isInstructorValid(), 'form is', this.state.formIsValid);
        console.log('button gets', !this._isInstructorValid(), !this.state.formIsValid);

        return (
            <div id="page-wrapper">
                <div id="page-content">
                    <div id="content"/>
                    <Row classes="align-items-center">
                        <Column grid="lg" size="6">
                            <h1 className="page-header">{this._determinePageTitle()}</h1>
                        </Column>
                    </Row>
                    <Column grid="lg" size="10" classes="offset-lg-1">
                        <div className="card card-default">
                            <div className="card-body">
                                <Row>
                                    <Column grid="lg" size="12">
                                        <Form key={this.formKey + this.state.workingResource.id} formKey={this.formKey}
                                              bindResource={this.state.workingResource}>
                                            <Row>
                                                <Column grid="sm" size="6">
                                                    <Row>
                                                        <Column grid="sm" size="4">
                                                            <Form.File fieldKey="image" options={{
                                                                height: 120,
                                                                width: 120,
                                                                b64encoded: true,
                                                                bgImage: this.state.workingResource.image
                                                            }}
                                                                       accept="image"
                                                                       label="Profile Photo"
                                                                       helpText="We recommend that you upload an image that is at least 1000px by 1000px."/>
                                                        </Column>

                                                        <Column grid="sm" size="8">
                                                            <Form.Input fieldKey="name" type="text" label="Name"
                                                                        placeholder="Name" limit={120}
                                                                        validations="isLength:4:120" required={true}/>
                                                            <Form.RadioButtons fieldKey="gender" label="Sex"
                                                                               options={genderSelect}/>
                                                        </Column>
                                                    </Row>
                                                </Column>

                                                <Column grid="sm" size="6">
                                                    <Row>
                                                        <Form.TextArea fieldKey="biography" label="Bio"
                                                                       placeholder="Enter biography.."
                                                                       required={true} limit={230}
                                                                       validations="isLength:1:230" rows="3"/>
                                                    </Row>
                                                    <Row>
                                                        <Form.TextArea fieldKey="quote" label="Quote/Mantra"
                                                                       placeholder="Enter quote.."
                                                                       required={true} limit={115}
                                                                       validations="isLength:1:115" rows="3"/>
                                                    </Row>
                                                </Column>
                                            </Row>

                                            <Row>
                                                <Column grid="sm" size="6">
                                                    <Form.Input fieldKey="user.username" type="email"
                                                                placeholder="Email Address"
                                                                validations="isEmail" limit={60}/>

                                                    <Form.TypeAheadInput fieldKey="genres" source="remote"
                                                                         resourceAction={this.genreActions}
                                                                         required={true}
                                                                         label="Selected Genres"
                                                                         placeholder="Search Genres.."
                                                                         limit={9} fields={['label']} options={{}}
                                                                         helpText="We recommend that you select at least 3, but no more than 9. Click in the field below and start typing to add a genre."/>
                                                </Column>

                                                <Column grid="sm" size="6">
                                                    <Form.Input fieldKey="user.password" type="password"
                                                                placeholder="Set Password"
                                                                limit={30} validations="isLength:6:16"/>

                                                    <Form.Input fieldKey="url" type="url" placeholder="URL"
                                                                validations="isURL"
                                                                limit={100}/>
                                                    <Form.Input fieldKey="order_wheel" type="number"
                                                                placeholder="Instructor Wheel Order number"
                                                                validations="isLength:1:99"
                                                                limit={2}/>
                                                    <Form.Input fieldKey="content_id" type="text"
                                                                placeholder="Content ID (3-4 characters, e.g. JC0)"
                                                                validations="isLength:3:4"
                                                                limit={4}/>
                                                </Column>
                                            </Row>
                                        </Form>
                                    </Column>
                                </Row>
                                <Row classes="justify-content-end">
                                    <Button action="goBack" text="Go Back" handleAction={this.handleAction}/>
                                    <Button action="save"
                                            disabled={!this._isInstructorValid() || !this.state.formIsValid} text="Save"
                                            handleAction={this.handleAction} mods={['primary']}/>
                                </Row>
                            </div>
                        </div>
                    </Column>
                </div>
            </div>
        );
    },
});

module.exports = EditInstructor;
